<div id="hours-pack-dialog-container" class="black">
  <div class="d-flex flex-end cursor-pointer">
    <img
      src="../../../assets/icon/close-circle.svg"
      alt=""
      (click)="closeDialog(true)"
    />
  </div>
  <div class="title margin-top-1 text-center">
    <p class="mat-h3 bold">
      Aprender no es prepararse para la vida.<br />Aprender es la vida misma
    </p>
    <p>NUESTROS PACKS DE HORAS:</p>
    <p>Comprar horas para el profesor<br>
    <strong class="primary">{{ teacher_info.name }} {{ teacher_info.surname }}</strong></p>
   
  </div>

  <form [formGroup]="form">
    <div class="container">
      <div class="row d-flex text-center hours-radio">
        <div class="col-6 col-md-3">
          <input
            formControlName="hours"
            type="radio"
            class="btn-check"
            name="hours"
            id="1"
            value="1"
            autocomplete="off"
            checked
          />
          <label for="1" class="d-flex flex-wrap flex-column"
            ><span class="mat-h3">1 HORA</span
            ><span class="mat-caption"
              >{{ priceHour | number: "1.2-2" }} €
            </span></label
          >
        </div>
        <div class="col-6 col-md-3">
          <input
            formControlName="hours"
            type="radio"
            class="btn-check"
            name="hours"
            id="5"
            value="5"
            autocomplete="off"
          />
          <label for="5" class="d-flex flex-wrap flex-column"
            ><span class="mat-h3">5 HORAS</span>
            <span class="mat-caption"
              >{{ threeDiscount | number: "1.2-2" }} €</span
            ></label
          >
        </div>
        <div class="col-6 col-md-3">
          <input
            formControlName="hours"
            type="radio"
            class="btn-check"
            name="hours"
            id="10"
            value="10"
            autocomplete="off"
          />
          <label for="10" class="d-flex flex-wrap flex-column"
            ><span class="mat-h3">10 HORAS</span
            ><span class="mat-caption"
              >{{ fiveDiscount | number: "1.2-2" }} €</span
            ></label
          >
        </div>
        <div class="col-6 col-md-3">
          <input
            formControlName="hours"
            type="radio"
            class="btn-check"
            name="hours"
            id="15"
            value="15"
            autocomplete="off"
          />
          <label for="15" class="d-flex flex-wrap flex-column"
            ><span class="mat-h3">15 HORAS</span>
            <span class="mat-caption"
              >{{ sevenDiscount | number: "1.2-2" }} €</span
            ></label
          >
        </div>
      </div>
      <div class="row pt-5 justify-content-center" *ngIf="!response_cupon">
        <h3><strong>¿Tienes un cupón?</strong></h3>
        <div class="input-group">
          <input
            type="text"
            formControlName="couponText"
            id="coupon_text"
            class="form-control"
            placeholder="Introduce el código aquí"
            aria-label="Introduce el código aquí"
            aria-describedby="button-addon3"
          />
          <button
            (click)="checkCoupon()"
            class="btn btn-outline-secondary validate-coupon"
            type="button"
            id="button-addon3"
            style="margin: 0px"
          >
            VALIDAR
          </button>
        </div>
      </div>
    </div>

    <div class="row payment-logos margin-top-1 pt-4">
      <div class="position-relative">
        <input
          formControlName="paymentMethod"
          type="radio"
          name="paymentMethod"
          id="paypal"
          value="paypal"
          autocomplete="off"
        />
        <label for="paypal">
          <img
            class="margin-right-1"
            src="../../../assets/img/paypal.png"
            alt=""
          />
        </label>
        <p class="comission-warn">
          Se aplica un 5% de comisión con un mínimo de 0'50€
        </p>
      </div>

      <div class="position-relative">
        <input
          formControlName="paymentMethod"
          type="radio"
          name="paymentMethod"
          id="redsys"
          value="redsys"
          autocomplete="off"
        />
        <label for="redsys">
          <img src="../../../assets/icon/card.svg" alt="" class="card-img" />
          {{ "payment-with-card" | translate }}
        </label>
        <p class="comission-warn redsys-warn">
          Se aplica un 2% de comisión con un mínimo de 0'50€
        </p>
      </div>
    </div>
    <div class="row mt-5 justify-content-center">
      <mat-checkbox class="acept-conditions" formControlName="conditions">
        He leído y acepto los
        <a href="#">Términos y Condiciones de contratación</a>
      </mat-checkbox>
    </div>

    <!-- START Cupones descuento importes -->
    <div *ngIf="response_cupon" class="border p-2 mt-3">
      <div *ngIf="response_cupon.coupon.discount_type == 0">
        <p class="text-center">
          <span class="success-coupon text center"
            >CUPÓN APLICADO CORRECTAMENTE</span
          >
        </p>
        <div class="text-center">
          <strong>{{ this.response_cupon.coupon.description }}</strong>
        </div>
      </div>
      <div *ngIf="response_cupon.coupon.discount_type == 2">
        <p class="text-center">
          <span class="success-coupon">CUPÓN APLICADO CORRECTAMENTE</span>
        </p>
        <div class="text-center">
          <strong
            >Se han añadido {{ response_cupon.coupon.value }} horas a tu cartera.
            </strong
          >
          <p>Serás redirigido automáticamente a la página del profesor.</p>
        </div>
      </div>

      <div *ngIf="response_cupon.coupon.discount_type == 1">
        <p class="text-center">
          <span class="success-coupon">CUPÓN APLICADO CORRECTAMENTE</span>
        </p>
        <div class="text-center">
          <strong
            >Se ha aplicado un descuento del {{ this.response_cupon.coupon.value }} %
            sobre los precios.</strong
          >
        </div>
      </div>
    </div>
    <!-- END Cupones descuento importes -->
    <input *ngIf="response_cupon"
      type="hidden"
      value="{{ response_cupon.coupon.coupon_text }}"
      formControlName="couponText"
      id="couponText"
    />
    <div class="d-flex flex-center margin-top-1">
      <button
        mat-raised-button
        color="primary"
        class="width-50 margin-top-1 margin-bottom-05 padding-05 register-icon"
        (click)="sendForm()"
        [disabled]="form.invalid"
      >
        <span>{{ "buy" | translate }}</span>
      </button>
    </div>
  </form>
</div>
